module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/201/assets/images/d01d2649c1dac12e6e7579b45c2689d4.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_three_essentials.svg
// module id = g6JL
// module chunks = 1